import NewOrderReturn from '@app/components/order_return/NewOrderReturn';
import React from 'react';

const OrderReturnNewPage: React.FC = () => {
  
  return (
    <NewOrderReturn />
  );
};

export default OrderReturnNewPage;
